'use client';

import { c as _c } from "react/compiler-runtime";
import { FC, ReactNode, useLayoutEffect, useRef, useState } from 'react';
import type { EnhancedStore } from '@reduxjs/toolkit';
import { Provider } from 'react-redux';
import { RootState } from '@spa/lib/store/RootState';
import { hydrate } from '@spa/lib/store/HydrateAction';
import { makeStore } from '@spa/lib/store/store';
import useFullPath from '@spa/lib/react/hooks/useFullPath';
export interface Props {
  readonly children: ReactNode;
  readonly serverState: Partial<RootState>;
}
const isCsr = typeof window !== 'undefined';
let cachedStore: EnhancedStore | null = null;
let cachedFullPath: string | null = null;
const getOrCreateStore = (serverState: Partial<RootState>): EnhancedStore => {
  if (!isCsr) {
    return makeStore(false, serverState);
  }
  cachedStore ??= makeStore(true, serverState);
  return cachedStore;
};
export function resetCache(): void {
  cachedStore = null;
  cachedFullPath = null;
}
const ReduxProvider: FC<Props> = t0 => {
  const $ = _c(10);
  const {
    children,
    serverState
  } = t0;
  const {
    fullPath
  } = useFullPath();
  let t1;
  if ($[0] !== serverState) {
    t1 = () => getOrCreateStore(serverState);
    $[0] = serverState;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [store] = useState(t1);
  const fullPathRef = useRef(cachedFullPath ?? fullPath);
  let t2;
  let t3;
  if ($[2] !== fullPath || $[3] !== serverState || $[4] !== store) {
    t2 = () => {
      if (fullPathRef.current !== fullPath) {
        store.dispatch(hydrate(serverState));
        fullPathRef.current = fullPath;
      }
      if (isCsr) {
        cachedFullPath = fullPath;
      }
    };
    t3 = [fullPath, serverState, store];
    $[2] = fullPath;
    $[3] = serverState;
    $[4] = store;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  useLayoutEffect(t2, t3);
  let t4;
  if ($[7] !== children || $[8] !== store) {
    t4 = <Provider store={store}>{children}</Provider>;
    $[7] = children;
    $[8] = store;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
export default ReduxProvider;